export const LIMIT_PAGE = 200;
export const TOTAL_PAGE = 1;
export const CURRENT_PAGE = 1;

export const SORT_ORDER = {
  ASC: "ASC",
  DESC: "DESC",
} as const;

export type SortOrderType = (typeof SORT_ORDER)[keyof typeof SORT_ORDER];
